import {ZyusetuFieldValueAnalyzedPayloadFragmentFragment} from "@/graphql/graphql";
import {Dialog, DialogContent, Paper, Table, TableBody, TableCell, TableContainer, TableRow,} from "@mui/material";
import {DocumentFieldOutput} from "@azure-rest/ai-document-intelligence";
import {MyDialogTitle} from "@/components/dialog/MyDialogTitle.tsx";

interface ZyusetuAzureArrayViewerProps {
  payload: ZyusetuFieldValueAnalyzedPayloadFragmentFragment;
  open: boolean;
  onClose: () => void;
}

export function ZyusetuAzureArrayViewerDialog({
                                                payload,
                                                open, onClose
                                              }: ZyusetuAzureArrayViewerProps) {
  // TODO:FIXME
  return (
    <>
      <Dialog
        maxWidth={"md"}
        fullWidth
        open={open}
        onClose={onClose}
      >
        <MyDialogTitle onClose={onClose}>画像から選択</MyDialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table sx={{minWidth: 650}} aria-label="simple table">
              <TableBody>
                {payload.azureFieldOutput.valueArray.map(
                  (value: DocumentFieldOutput) => {
                    return (
                      <TableRow key={`valueArray-${value}`}>
                        {value.valueObject &&
                          Object.values(value.valueObject).map((value) => (
                            <TableCell key={`valueArray-content-${value}`}>{value.valueString}</TableCell>
                          ))}
                      </TableRow>
                    );
                  },
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </>
  );
}
